import React, { useState } from 'react';
import useGetSendersByCountry from '../hooks/useGetSendersByCountry';

function SendersByCountry({ organizationId }) {
  const [timeRange, setTimeRange] = useState('7d');
  const { data, loading, error } = useGetSendersByCountry(organizationId, timeRange);

  const timeRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: '24h', label: '24 Hours' },
    { value: '7d', label: '7 Days' },
    { value: '30d', label: '30 Days' },
    { value: '90d', label: '90 Days' }
  ];

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>Loading sender countries...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '20px', color: '#d32f2f' }}>
        Error loading data: {error}
      </div>
    );
  }

  if (!data || !data.countries || Object.keys(data.countries).length === 0) {
    return (
      <div style={{ padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 className="text-lg md:text-xl font-bold text-black" style={{ margin: 0 }}>Senders by Country</h3>
          <select
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
            style={{
              padding: '8px 12px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              fontSize: '14px'
            }}
          >
            {timeRangeOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
          No sender data available for this time range
        </div>
      </div>
    );
  }

  const countries = Object.entries(data.countries);
  const maxCount = Math.max(...countries.map(([_, count]) => count));

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3 className="text-lg md:text-xl font-bold text-black" style={{ margin: 0 }}>Senders by Country</h3>
        <select
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
          style={{
            padding: '8px 12px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            fontSize: '14px',
            cursor: 'pointer'
          }}
        >
          {timeRangeOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: '20px', fontSize: '14px', color: '#666' }}>
        <div>Total Senders: <strong>{data.total_senders}</strong></div>
        <div>Unique IPs: <strong>{data.unique_ips}</strong></div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {countries.map(([country, count]) => {
          const percentage = ((count / maxCount) * 100).toFixed(1);
          return (
            <div key={country} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ minWidth: '150px', fontSize: '14px', fontWeight: '500', color: '#000' }}>
                {country}
              </div>
              <div style={{ flex: 1, position: 'relative', height: '24px', backgroundColor: '#f0f0f0', borderRadius: '4px', overflow: 'hidden' }}>
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: `${percentage}%`,
                    backgroundColor: '#02A0B0',
                    transition: 'width 0.3s ease'
                  }}
                />
                <div style={{ position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', fontWeight: '600', color: percentage > 50 ? '#fff' : '#333' }}>
                  {count}
                </div>
              </div>
              <div style={{ minWidth: '60px', textAlign: 'right', fontSize: '14px', color: '#666' }}>
                {((count / data.total_senders) * 100).toFixed(1)}%
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SendersByCountry;
